import { observer } from 'mobx-react-lite';
import modalStore, { ModalOption } from '@client/store/modalStore';
import StockModalBasicInfo from '@app/haewao/client/view/stock/StockModalBasicInfo';
import StockModalPriceInfo from '@app/haewao/client/view/stock/StockModalPriceInfo';
import Carousel, { useCarouselContext } from '@app/haewao/client/view/common/Carousel';
import { Modal } from '@client/component/modal/Modal';
import { useCommonNavigate } from '@client/component/CommonLink';
import { createPlugin } from '@client/component/modal/modalPlugin';

/**
 * StockModalContent - 캐러셀 슬라이드 내용
 * - CarouselProvider context 내부에서 실행되어야 함
 */
const StockModalContent = observer(({ ticker }: { ticker: string }) => {
    const { carouselStore } = useCarouselContext();
    const isPriceSlideActive = carouselStore.currentSlideIndex === 1;

    return (
        <Modal.ModalCarouselContainer>
            <Carousel.Slide className="px-5">
                <StockModalBasicInfo ticker={ticker} />
            </Carousel.Slide>
            <Carousel.Slide className="px-5">
                <StockModalPriceInfo ticker={ticker} disableFetch={!isPriceSlideActive} />
            </Carousel.Slide>
        </Modal.ModalCarouselContainer>
    );
});

/**
 * 주식 정보 모달
 * - 캐러셀 형태로 기본 정보와 가격 정보를 슬라이드로 제공
 */
const StockModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const ticker = option.stock?.ticker;
    const { navigate } = useCommonNavigate();

    if (!ticker) {
        return null;
    }

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.ModalCarousel>
                <StockModalContent ticker={ticker} />
            </Modal.ModalCarousel>
            <div className="mt-5 px-5">
                <button
                    className="btn btn-soft btn-block"
                    onClick={async (e) => {
                        e.preventDefault();
                        navigate(`/stock/${ticker}`);
                        await modalStore.close(modalId);
                    }}
                >
                    자세히 보기
                </button>
            </div>
        </Modal.Dialog>
    );
});

/**
 * 해와오 주식 정보 모달 플러그인
 */
export const stockPlugin = createPlugin({
    type: 'haewaoStock' as const,
    component: StockModal,
    createModalOption: ({ ticker }: { ticker: string }) => ({
        backdrop: true,
        preventClose: false,
        showCloseButton: true,
        stock: {
            ticker,
        },
    }),
});
